<template>
  <!--==================
    component shows all new operators in operator management page
    ===============-->

  <div class="col-12 pb-20 pt-20 px-0">
    <div class="card">
      <div class="table-responsive">
        <table class="table table-sm table-nowrap card-table">
          <thead class="text-primary">
            <tr>
              <th>#</th>
              <th>COMPANY NAME</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(operator, index) in operators"
              :key="operator.id"
              :data-position="operator.position"
              :data-id="operator.id"
            >
              <td>{{ index + 1 }}</td>
              <td class="font-weight-bold">
                <span class="text-primary p-3" href="#">{{ operator.companyName }}</span>
              </td>
              <td class="text-right">
                <button
                  @click="aprove($event)"
                  class="btn btn-sm btn-success mr-2"
                  :data-id="operator.id"
                  :data-index="index"
                >
                  Aprove
                </button>
                <button @click="edit($event)" class="btn btn-sm btn-primary mr-2" :data-id="operator.id">Edit</button>
                <button
                  @click="remove($event)"
                  class="btn btn-sm btn-danger ml-2"
                  :data-id="operator.id"
                  :data-index="index"
                >
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "NewOperator",

  computed: {
    ...mapGetters(["newOperators"]),

    operators() {
      return this.newOperators;
    },
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchNewOperators();
    });
  },

  methods: {
    ...mapActions(["fetchNewOperators", "aproveOperator", "deleteOperator"]),

    aprove(e) {
      let id = e.target.getAttribute("data-id");
      this.aproveOperator(id);
    },

    edit(e) {
      let id = e.target.getAttribute("data-id");

      window.open("/dashboard/user/setting/" + id, "_blank");
    },

    remove(e) {
      let id = e.target.getAttribute("data-id");
      let index = e.target.getAttribute("data-index");
      let dP = this;

      $.confirm({
        title: "",
        content: "Are you sure want to delete this operator?",
        buttons: {
          confirm: () => {
            dP.deleteOperator({ id, flag: "new" });
          },
          cancel: () => {},
        },
      });
    },
  },
};
</script>
